



































































import Vue, { PropType } from "vue";

import BaseWidgetInformationCard from "./BaseWidgetInformationCard.vue";
import WidgetViewConfigCard from "./WidgetViewConfigCard.vue";
import WidgetFilterCard from "./WidgetFilterCard.vue";
import WidgetPreviewCard from "./WidgetPreviewCard.vue";

import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { CreateDashboardWidgetCommand } from "@/model/communication/dashboard/widget/CreateDashboardWidgetCommand";
import { UpdateDashboardWidgetCommand } from "@/model/communication/dashboard/widget/UpdateDashboardWidgetCommand";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { WidgetViewTypesEnum } from "@/model/data/dashboard/WidgetViewTypesEnum";
import { WidgetTypesEnum } from "@/model/data/dashboard/WidgetTypesEnum";

export default Vue.extend({
    components: {
        BaseWidgetInformationCard,
        WidgetViewConfigCard,
        WidgetPreviewCard,
        WidgetFilterCard,
    },
    data() {
        return {
            showPreview: true,
            errorMessage: "",
            currentStep: 0,
            steps: [
                {
                    name: this.$t("dashboard.basicInformation"),
                    icon: "file",
                    component: BaseWidgetInformationCard,
                },
                {
                    name: this.$t("dashboard.viewConfigParameters"),
                    icon: "chart-area",
                    component: WidgetViewConfigCard,
                },
                {
                    name: this.$t("dashboard.filters"),
                    icon: "filter",
                    component: WidgetFilterCard,
                },
            ],
        };
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
        isNew: Boolean,
    },
    computed: {
        canDoPreviousStep() {
            return this.currentStep > 0;
        },
        canDoNextStep() {
            return this.currentStep < this.steps.length - 1;
        },
        canDoLivePreview() {
            if (this.widget && this.widget.widgetType)
                return (
                    (this.widget as DashboardWidget).widgetType != WidgetTypesEnum.CashCount &&
                    (this.widget as DashboardWidget).widgetType != WidgetTypesEnum.Transactions &&
                    (this.widget as DashboardWidget).widgetType != WidgetTypesEnum.InstallationsStatusChanges
                );
            return false;
        },
    },
    watch: {
        widget: {
            deep: true,
            handler(value: DashboardWidget) {
                let availableWidgetTypes: Array<WidgetViewTypesEnum> = value.getAvailableViewType().map((c) => c.value);
                if (!availableWidgetTypes.includes(value.viewConfig.viewType)) {
                    value.viewConfig.viewType = availableWidgetTypes[0];
                }
                setTimeout(this.$refs.widgetPreviewCard.fetchWidgetData(value));
            },
        },
    },
    methods: {
        previousStep() {
            if (this.canDoPreviousStep) this.currentStep--;
        },
        nextStep() {
            if (this.canDoNextStep) this.currentStep++;
        },
        onCancelClick() {
            this.$emit("close");
        },

        fetchAndClose() {
            this.$emit("fetch");
            this.$emit("close");
        },

        async onSaveClick() {
            try {
                let res: ApiGenericResponse;

                if (this.isNew) res = await new CreateDashboardWidgetCommand(this.widget).execute();
                else {
                    console.log("widget: ", this.widget);
                    res = await new UpdateDashboardWidgetCommand(this.widget, null).execute();
                }

                if (res.responseStatus != ApiResponseStatusEnum.Success) {
                    console.error("Error trying create/update widget with id: ", this.widget.id);
                    this.errorMessage = this.$t("dashboard.cannotSaveWidget");
                }
                this.fetchAndClose();
            } catch (error) {
                this.errorMessage = this.$t("dashboard.cannotSaveWidget");
                console.error("Error trying create/update widget with id: ", this.widget.id, " error: ", error);
                this.fetchAndClose();
            }
        },

        // onWidgetTypeChange() {
        //     console.log("onWidgetTypeChange");
        //     apiFetchWidgetViewTypes(this.WidgetConfig).then((res) => {
        //         if (res.status == 200) {
        //             if (!res.data.map((v) => v.id).includes(this.WidgetConfig.ViewConfig.ViewType)) {
        //                 // console.log("Widget type change, ViewType: ", res.data[0].id);
        //                 this.WidgetConfig.ViewConfig.ViewType = res.data[0].id;
        //             }
        //         } else {
        //             console.error("cannot fetch view types", res);
        //         }
        //     });
        // },
    },
});
